<template>
    <div class="terms-of-service">
        <md-card style="max-width:1000px;margin:10px auto;">
            <md-card-header>
                <h1 class="md-title">Financing</h1>
            </md-card-header>
            <md-card-content v-html="content">
            </md-card-content>
        </md-card>
    </div>
</template>
<script>
export default {
    data() {
        return {
            content: ""
        };
    },
    methods: {
        async get() {
            var result = await this.$store.dispatch("crud/get", {
                api: "settings/financing"
            });
            if (result) {
                this.content = result.value;
            }
        }
    },
    mounted() {
        this.get();
    }
};
</script>
